// Catalogage par l’image : sorties bornées et décisions humaines champ par champ.
import { z } from 'zod';
export const CHAMPS_CATALOGAGE = [
    'description',
    'motsCles',
    'technique',
    'cartel',
    'biographie',
];
export const NATURES_LECTURE_VERSO = [
    'etiquette_exposition',
    'etiquette_vente',
    'etiquette_encadreur',
    'etiquette_transport',
    'etiquette_collection',
    'tampon',
    'inscription',
    'signature',
    'numero',
    'autre',
];
export const etatDecisionCatalogageSchema = z.enum(['proposee', 'acceptee', 'modifiee', 'refusee']);
export const texteCatalogageSchema = (max) => z.strictObject({ fr: z.string().max(max), en: z.string().max(max) });
export const motsClesCatalogageSchema = z.array(z.string().trim().min(1).max(60)).max(15);
export const sortieRectoSchema = z.strictObject({
    description: texteCatalogageSchema(1200),
    motsCles: motsClesCatalogageSchema,
    technique: z.strictObject({
        fr: z.string().max(500),
        en: z.string().max(500),
        incertain: z.boolean(),
    }),
    cartel: texteCatalogageSchema(400),
});
export const ligneVersoSchema = z.strictObject({
    type: z.enum(['proprietaire', 'exposition', 'publication', 'mention']),
    libelle: z.string().trim().min(1).max(300),
    periode: z.string().max(120).nullable(),
});
export const lectureVersoSchema = z.strictObject({
    nature: z.enum(NATURES_LECTURE_VERSO),
    texteLu: z.string().max(500),
    institution: z.string().max(300).nullable(),
    lieu: z.string().max(300).nullable(),
    date: z.string().max(120).nullable(),
    numero: z.string().max(120).nullable(),
    lisibilite: z.enum(['bonne', 'partielle', 'faible']),
    ligneProposee: ligneVersoSchema.nullable(),
});
export const sortieVersoSchema = z.strictObject({ lectures: z.array(lectureVersoSchema).max(40) });
export const sortieBiographieSchema = z.strictObject({ biographie: texteCatalogageSchema(2000) });
const id = z.string().regex(/^[a-f\d]{24}$/i);
export const preparationImagesSchema = z.strictObject({
    mediaIds: z
        .array(id)
        .min(1)
        .max(4)
        .refine((v) => new Set(v).size === v.length),
});
export const preparationBiographieSchema = z.strictObject({
    texte: z.string().max(10000).default(''),
});
export const preparationSerieSchema = z.strictObject({
    oeuvreIds: z
        .array(id)
        .min(1)
        .max(50)
        .refine((v) => new Set(v).size === v.length),
});
export const decisionCatalogageSchema = z.strictObject({
    version: z.int().nonnegative(),
    versionFiche: z.iso.datetime(),
    decision: z.enum(['accepter', 'modifier', 'refuser']),
    valeur: z
        .union([texteCatalogageSchema(2000), motsClesCatalogageSchema, lectureVersoSchema])
        .optional(),
    destination: z.enum(['notes', 'provenance']).optional(),
});
export const champCatalogageSchema = z.strictObject({
    champ: z.enum(CHAMPS_CATALOGAGE),
    valeur: z.union([texteCatalogageSchema(2000), motsClesCatalogageSchema]),
    incertain: z.boolean(),
    etat: etatDecisionCatalogageSchema,
    decidePar: z.string().nullable(),
    decideLe: z.iso.datetime().nullable(),
});
export const propositionCatalogageSchema = z.strictObject({
    id,
    oeuvreId: id.nullable(),
    artisteId: id.nullable(),
    type: z.enum(['recto', 'verso', 'biographie']),
    mediaIds: z.array(id),
    etat: z.enum(['en_cours', 'prete', 'echec', 'close']),
    cause: z.string().nullable(),
    champs: z.array(champCatalogageSchema),
    lectures: z.array(lectureVersoSchema.extend({
        etat: etatDecisionCatalogageSchema,
        decidePar: z.string().nullable(),
        decideLe: z.iso.datetime().nullable(),
    })),
    appelId: z.string().nullable(),
    creePar: z.string(),
    creeLe: z.iso.datetime(),
    modifieLe: z.iso.datetime(),
    version: z.int().nonnegative(),
    versionFiche: z.iso.datetime(),
});
export const cartelCatalogageSchema = texteCatalogageSchema(400).extend({
    oeuvreId: id,
    version: z.int().nonnegative(),
    modifiePar: z.string(),
    modifieLe: z.iso.datetime(),
});
export const serieCatalogageSchema = z.strictObject({
    id,
    oeuvreIds: z.array(id),
    etat: z.enum(['en_cours', 'terminee', 'arretee']),
    traitees: z.int(),
    pretes: z.int(),
    echecs: z.int(),
    restantes: z.int(),
    cause: z.string().nullable(),
    creeLe: z.iso.datetime(),
});
export const tableauCatalogageSchema = z.strictObject({
    propositions: z.array(propositionCatalogageSchema),
    libelles: z.record(z.string(), z.string()).default({}),
    serie: serieCatalogageSchema.nullable(),
    cartels: z.array(cartelCatalogageSchema),
});
//# sourceMappingURL=catalogage.js.map